var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('div',{staticClass:"toast-container"},[_c('transition-group',{attrs:{"name":"toast-fade"}},_vm._l((_vm.toasts),function(t){return _c('div',{key:t.id,staticClass:"toast-item",class:'toast-' + t.type},[_vm._v(" "+_vm._s(t.msg)+" ")])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }